export default function CPointersArrays() {
  return <h2>C Pointers Arrays</h2>;
}
